<footer #footer>
  <div class="footer-wrap">
    <ul class="footer-menu-list">

      <li *ngIf="!systemSvc.android">
        <a (click)="onBackBtn($event)">
          <i class="ic ic-back"></i>
          <div class="txt">뒤로 가기</div>
        </a>
      </li>


      <li>
        <a [routerLink]="['/main']" class="{{ FooterOn === FOOTER_ON.HOME ? 'on' : '' }}">
          <i class="ic ic-home"></i>
          <div class="txt">첫 화면</div>
        </a>
      </li>

      <li>
        <a [routerLink]="['/movie-collect']" class="{{ FooterOn === FOOTER_ON.MOVIE_COLLECT ? 'on' : '' }}">
          <i class="ic ic-movie"></i>
          <div class="txt">동영상 모아 보기</div>
        </a>
      </li>

      <li>
        <a class="{{ FooterOn === FOOTER_ON.BOOKMARK ? 'on' : '' }}"
           (click)="lm.showBookmark = true">
           <!-- (click)="lm.showBookmark = true; bookmark.emit(true)" -->
          <i class="ic ic-bookmark"></i>
          <div class="txt">책갈피</div>
        </a>
      </li>

      <li>
        <a #btnScrollDown
           class="{{ getClassScrollDown() }}"
           (mousedown)="onStartScrollDown($event)"
           (mouseup)="onEndScrollDown($event)"
           (mouseleave)="onEndScrollDown($event)"
           (touchend)="onEndScrollDown($event)"
           (touchcancel)="onEndScrollDown($event)">
          <i class="ic ic-down"></i>
          <div class="txt">아래로 내리기</div>
        </a>
      </li>
    </ul>
  </div>
</footer>
